import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import analytics from '../utils/analytics';

/**
 * Fires a PostHog $pageview on every route change.
 * Place inside <Router>.
 */
export default function PageViewTracker() {
  const location = useLocation();

  useEffect(() => {
    analytics.pageview(window.location.href);
  }, [location.pathname, location.search]);

  return null;
}
